const SoftMenu = [
    {
      id: 1,
      MainImage: "https://icdn.digitaltrends.com/image/digitaltrends/amazon-echo-2nd-gen-and-echo-dot-3rd-gen-1500x1000.jpg",
      name: "Alexa Amazon or Torr ?",
      category: "Softwares",
      description:
        "Alexa is always listening to your conversations. So turn off that thing when not needed",
    },
    {
        id: 2,
        MainImage: "https://blog.mozilla.org/performance/files/2021/10/red_panda_sleeping-1400x770.jpg",
        name: "Fox-The Final Conclusion",
        category: "Softwares",
        description:
          "The English word for the red panda is Firefox. This means that the Logo is actually a red panda, not a fox",
      },
      {
        id: 3,
        MainImage: "https://pbs.twimg.com/media/Dyp7gjrWwAA5vIv.jpg",
        name: "First smartphone brand ?",
        category: "Softwares",
        description:
          "Although IBM takes the credit for making the first “Smartphone” in the early 1990s, it was in the year 2010-2011",
      },
      {
        id: 4,
        MainImage: "https://www.thefactsite.com/wp-content/uploads/2019/12/robot-origin.webp",
        name: "“Robot” has dark origins",
        category: "Softwares",
        description:
          "If you look into the etymology of “robot,” it comes from the Czech word “robota” which translates to forced labor or work.",
      },
      {
        id: 5,
        MainImage: "https://miro.medium.com/max/1200/1*01tRFr56GISV-sZgNBubbA.jpeg",
        name: "First Computer Mouse",
        category: "Softwares",
        description:
          "Back in 1964, Doug Engelbart invented the first-ever computer mouse! Back then, it was made out of wood.",
      },
      {
        id: 6,
        MainImage: "https://www.thefactsite.com/wp-content/uploads/2019/12/usb-plug-upside-down.webp",
        name: "You are not only one here",
        category: "Softwares",
        description:
          "According to a survey, 86% of people try to plug in their USB devices upside down. Now feel better right ?",
      },
      {
        id: 7,
        MainImage: "https://www.getsupport.co.uk/wp-content/uploads/2020/07/computer-security-101.jpg",
        name: "Computer Sequrity Day",
        category: "Softwares",
        description:
          "It was started in 1992. Now Computer Security Day is celebrated on every November 30th.",
      },
      {
        id: 8,
        MainImage: "https://cdn.pocket-lint.com/r/s/1200x/assets/images/73106-games-review-sony-ps3-slim-image10-uam7djlpai.jpg",
        name: "PS3 under Government ?",
        category: "Softwares",
        description:
          "In 2010, the United States Air Force used 1,760 PlayStation 3 consoles for the Department of Defense.",
      },
      {
        id: 9,
        MainImage: "https://www.thefactsite.com/wp-content/uploads/2019/12/surgeon-skills.webp",
        name: "Gamer Surgeon vs Normal",
        category: "Softwares",
        description:
          "Oddly enough, surgeons that grew up playing video games more than 3 hours per week make 37% fewer errors!",
      },
      {
        id: 10,
        MainImage: "https://r1.community.samsung.com/t5/image/serverpage/image-id/4346367i79B975ECA60D7FAD/image-size/large?v=v2&px=999",
        name: "Google-A Spell Checker",
        category: "Softwares",
        description:
          "Most everyone, anyway! 97% of people type in words to Google just to see if they spelled it right.",
      },
  
  ];
  
  export default SoftMenu;
  